import { sortMapByIndex } from "@/components/FormEngine/helpers/sortFields";
import { FormSection } from "@/components/FormEngine/types";

import { StyledSectionContainer, StyledSectionTitle } from "../../styles";
import { BaseRendererProps } from "../../types";
import { SubSectionRenderer } from "../SubSectionRenderer";

interface SectionRendererProps extends BaseRendererProps {
  section: FormSection;
  sectionIndex: number;
  fieldsMap?: Record<string, any>; // NEW
}

export const SectionRenderer: React.FC<SectionRendererProps> = ({
  section,
  sectionIndex,
  formState,
  onFieldChange,
  fieldsMap, // NEW
}) => (
  <StyledSectionContainer>
    {sectionIndex !== -1 && (
      <StyledSectionTitle variant='title1' gutterBottom>
        Section {sectionIndex}
      </StyledSectionTitle>
    )}

    {sortMapByIndex(section.subSections).map(
      ([subSectionIndex, subSection]) => (
        <SubSectionRenderer
          key={subSection.id}
          subSection={subSection}
          subSectionIndex={subSectionIndex}
          formState={formState}
          onFieldChange={onFieldChange}
          fieldsMap={fieldsMap} // NEW
        />
      ),
    )}
  </StyledSectionContainer>
);
